import Flickity from 'flickity';

export default (el) => {
  return new Flickity(el, {
    initialIndex: 0,
    prevNextButtons: true,
    pageDots: true,
    wrapAround: true,
    adaptiveHeight: false,
    draggable: true,
    dragThreshold: 10,
  });
};
